import { ProductUi } from '@/components/Cart/modal/CartUiModel';
import { SellerFilter } from '@/components/SellerFilter/SellerFilter';
import SearchIcon from '@mui/icons-material/Search';
import {
  Autocomplete,
  CircularProgress,
  Stack,
  TextField,
} from '@mui/material';
import React from 'react';
import { producUiToSearchResultLabel } from '../../mapper';
import { useProductSearchViewController } from './ProductSearchViewController';

export default function ProductSearch(props: {
  onProductSelected: (product?: ProductUi) => void;
  alreadyAddedProductIds: string[];
}) {
  const { uiState, actions } = useProductSearchViewController(
    props.alreadyAddedProductIds
  );

  return (
    <Stack direction={{ sx: 'column', md: 'row' }} gap={'12px'}>
      <SellerFilter
        sx={{ flex: '1 1 30%' }}
        onFilterChanged={actions.onFilterChanged}
      />
      <Autocomplete
        sx={{ flex: '1 1 50%' }}
        freeSolo={false}
        popupIcon={<></>}
        options={uiState.productOptions}
        noOptionsText={''}
        getOptionLabel={(option) => producUiToSearchResultLabel(option)}
        getOptionKey={(option) => option.id}
        filterOptions={(x) => x}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Agregar o buscar productos"
            InputProps={{
              ...params.InputProps,
              startAdornment: <SearchIcon />,
              endAdornment: (
                <React.Fragment>
                  {uiState.isSearching ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onInputChange={(_e, newInputValue) => {
          actions.scheduleSearch(newInputValue);
        }}
        onChange={(_, product) => {
          props.onProductSelected(product ?? undefined);
        }}
        value={null}
      />
    </Stack>
  );
}
